import LocationsNav from './LocationsNav';

export default LocationsNav;
